var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPersonal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 403,
    height: 403,
    viewBox: "0 0 403 403",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_119_43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.444 0H0V402.444H402.444V0Z",
    fill: "#ECF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.715 159.506C197.107 159.506 218.501 137.976 218.501 111.418C218.501 84.8591 197.107 63.3291 170.715 63.3291C144.324 63.3291 122.93 84.8591 122.93 111.418C122.93 137.976 144.324 159.506 170.715 159.506Z",
    stroke: "#2064A1",
    strokeWidth: 18.8976,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.259 192.033C221.076 189.077 213.204 187.449 204.941 187.449H138.825C104.839 187.449 77.478 214.983 77.478 249.185V322.218C77.478 331.579 84.9661 339.114 94.2676 339.114H249.498C258.799 339.114 266.287 331.579 266.287 322.218V302.784",
    stroke: "#2064A1",
    strokeWidth: 18.8976,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.375 169.447L324.967 196.039L242.377 278.629L212.093 282.321L215.785 252.037L298.375 169.447Z",
    stroke: "#2064A1",
    strokeWidth: 18.8977,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.156 195.666L298.748 222.258",
    stroke: "#2064A1",
    strokeWidth: 18.8977
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 402.444,
    height: 402.444,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPersonal);
export default __webpack_public_path__ + "static/media/icon_personal.6ccf7832115364bda5d01338261fb7f8.svg";
export { ForwardRef as ReactComponent };